import { render } from "./MultiviewDashboard.vue?vue&type=template&id=61d0870f"
import script from "./MultiviewDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiviewDashboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/MultiviewDash/MultiviewDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61d0870f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61d0870f', __exports__)) {
    api.reload('61d0870f', __exports__)
  }
  
  module.hot.accept("./MultiviewDashboard.vue?vue&type=template&id=61d0870f", () => {
    api.rerender('61d0870f', render)
  })

}


export default __exports__